<template>
  <div class="container" v-title data-title="阅伴教师端App下载">
    <div class="container-content">
      <img class="bg" src="../../assets/download/teacher-download-bg.png" />
      <div class="container-download ripple" @click="onDownLoad">点 击 立 即 下 载 教 师 端</div>
    </div>

    <!-- 内容导航 -->
    <div class="container-guide" v-if="isShowGuide">
      <img src="../../assets/download/download-guide.png" />
    </div>

  </div>
</template>

<script>

export default {
  data() {
    return {
      iosLink: "itms-apps://itunes.apple.com/app/id1240291945",
      androidLink: "https://yueban.oss-cn-shanghai.aliyuncs.com/android/app-teacher-112.apk",
      // 设备信息
      browserInfo: {
        userAgent: navigator.userAgent.toLowerCase(),
        isAndroid: Boolean(navigator.userAgent.match(/android/gi)),
        isIphone: Boolean(navigator.userAgent.match(/iphone|ipod/gi)),
        isIpad: Boolean(navigator.userAgent.match(/ipad/gi)),
        isWeixin: Boolean(navigator.userAgent.match(/MicroMessenger/gi)),
      },
      isShowGuide: Boolean(navigator.userAgent.match(/MicroMessenger/gi))
    };
  },
  methods: {

    /**
     * 立即下载
     */
    onDownLoad () {
      if (this.browserInfo.isAndroid) {
        this.onDownloadTeacherAndroid()
      } else {
        this.onDownloadTeacherIos()
      }
    },

    /**
     * 下载安卓版教师端
     */
    onDownloadTeacherAndroid() {
      window.location.href = this.androidLink;
    },

    /**
     * 下载苹果版教师端
     */
    onDownloadTeacherIos() {
      window.location.href = this.iosLink;
    },
  },
  created() {
    if (!this.browserInfo.isWeixin) {
      this.onDownLoad()
    }
  },
};
</script>

<style lang="scss" scoped>
// 父容器
.container {
  min-height: 100vh;
  height: 100%;
  width: 100vw;
  background-color: #e8fbfcff;
  // position: relative;

  // 内容
  .container-content {
    display: block;
    position: relative;
    // 背景
    .bg {
      margin-top: 58px;
      width: 100%;
      height: auto;
    }

    .container-download {
      position: absolute;
      top: 75%;
      right: 17%;
      width: 66%;
      height: 42px;
      line-height: 42px;
      background: linear-gradient(
          90deg,
          #77c1b6 0%,
          #77c1b6 0%,
          #8fdbaa 100%,
          #8fdbaa 100%
        );
      border-radius: 5px;
      opacity: 1;
      font-size: 15px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: #ffffff;
      text-align: center;
    }
  }

  // 导航
  .container-guide {
    position: absolute;
    top: 0;
    left: 0;
    width: 100vw;
    height: 100vh;
    background: rgba(0, 0, 0, 0.8);
    img {
      margin-left: 5%;
       width: 90%;
       height: auto;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/download/DownloadTeacher.vue